import { useNavigate } from 'react-router-dom'

import { Box, Button, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { useDateBookingContext } from 'modules/space_control/components/dateBookingContext'
import { WorkSpaceWithBookingNode } from 'modules/space_control/hooks/useWorkSpacesWithBookings'

interface Props {
  workSpace: WorkSpaceWithBookingNode
}

const WorkSpaceCard = ({ workSpace }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const spaceControl = useDateBookingContext()
  const onClickAddBooking = () => {
    track(trackingEvents.spaceControl.bookings.addBooking, {
      type_space: workSpace.workSpaceTypeName,
      capacity: workSpace.originalCapacity,
    })
    navigate(
      navigation.spaceControl.overview.booking.fullPath({
        date: dateToString(spaceControl.date, 'backend'),
        workSpaceId: workSpace.workSpaceId ?? '',
      })
    )
  }

  return (
    <Box
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      padding="s16"
    >
      <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
        <Text.Normal ellipsis color="grey1000" weight="medium">
          {workSpace.workSpaceName}
        </Text.Normal>
        <Button type="secondary" onClick={onClickAddBooking} disabled={workSpace.isFull}>
          {i18n.t('space_control.overview.book')}
        </Button>
      </Box>

      <Box flexDirection="column" gap="s16">
        <Text.Normal color="grey800" size="200">
          {i18n.tp('settings.locations.location.work_spaces.capacity_count', {
            count: workSpace.originalCapacity || 0,
          })}
        </Text.Normal>
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Box alignItems="flexStart">
            <Tag type="grey">{workSpace.workSpaceTypeName}</Tag>
          </Box>
          {workSpace.isFull && (
            <Box alignItems="flexStart">
              <Tag leftItem="circle" type="radical" showCircle>
                {i18n.t('space_control.overview.is_full')}
              </Tag>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default observer(WorkSpaceCard)
